import React, { useEffect, useState } from "react";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { useNavigate } from "react-router-dom";

import Topbar from "../../../Component/Topbar/Topbar";
import { Table } from "../../../Component/Table/Table";
import { edit, search, view } from "../../../assets/img";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import DateRange from "../../../Component/DateRange/DateRange";
import SelectBox from "../../../Component/SelectBox";
import { get, post } from "../../redux/api/ApiHandler";
import { URLS } from "../../redux/api/Constants";
import moment from "moment";
import useSearchFunction from "../../../Component/searchFunction";
const NextVisit = () => {
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [superAdmin, setSuperAdmin] = useState();
  const [pagination, setPagination] = useState("");
  const [selected, setSelected] = useState(null);
  const [statusVal, setStatusVal] = useState(null);
  const [regionOptions, setRegionOptions] = useState([]);
  const [fromDates, setFromDates] = useState(null);
  const [toDates, setToDates] = useState(null);
  const [selFrom, setSelFrom] = useState("");
  const [selTo, setSelTo] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [count, setCount] = useState(0);

  const debounceval = useSearchFunction(searchValue);

  const statusMap = {
    yet_to_start: { label: "Yet to Start", className: "yet_to_start_btn" },
    dispatched: { label: "Dispatched", className: "dispatched_btn" },
    delivered: { label: "Delivered", className: "delivered_btn" },
  };

  const ticketList = async (search, selected, fromDate, toDate) => {
    setSearchValue(search);
    setFromDates(fromDate);
    setToDates(toDate);
    setSelected(selected);

    let payload = {
      search: search,
      // page: page,
      region_id: selected?.value,
      // current_status: 7,
      type: 2,
      from_date: fromDate ? moment(fromDate).format("DD-MM-YYYY") : "",
      to_date: toDate ? moment(toDate).format("DD-MM-YYYY") : "",
    };
    let res = await post(URLS.TICKET_LIST, payload);
    if (res?.status == "success") {
      let array = [7, 8];
      let arr = res?.lists.filter((item) =>
        array.includes(item?.current_status)
      );
      setCount(arr.length);

      // 2️⃣ Handle current_status == 8 + last assigned_for == 2
      // res?.lists.forEach(item => {

      //   if (item.current_status === 8) {

      //     const latestMatch = [...item.ticket_details]
      //       .reverse()
      //       .find(i => i?.assigned_for === 1);

      //     if (latestMatch) {
      //       arr.push({
      //         ...item,
      //         last_assigned_detail: latestMatch   // merged detail
      //       });
      //     }
      //   }
      // });
      setList(arr);
      setPagination(res?.pagination_meta);
    }
  };

  const regionList = async () => {
    let res = await get(URLS.REGIONLIST);
    if (res?.status === "success" && Array.isArray(res?.roles)) {
      // 🔹 Convert API data to Select options
      const options = res?.roles.map((region) => ({
        value: region?.id,
        label: region?.name,
      }));
      setRegionOptions(options);
    }
  };

  useEffect(() => {
    ticketList(debounceval);
    regionList();
  }, [debounceval, page]);

  const statusOptions = [
    { value: "north", label: "Yet to Start" },
    { value: "south", label: "Dispatched" },
    { value: "east", label: "Delivered" },
  ];

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{(page - 1) * 10 + row.index + 1}</p>;
        },
      },

      {
        Header: "Regional Ticket ID",
        accessor: "code",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Region",
        accessor: "region",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Regional Manager",
        accessor: "regional_manager",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Service Engineer",
        accessor: "service_engineer",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Customer ID",
        accessor: "customer.code",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Customer Name",
        accessor: "customer",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value?.name}</p>;
        },
      },

      {
        Header: "Created By",
        accessor: "created_by",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value?.name}</p>;
        },
      },

      {
        Header: "Date",
        accessor: "opened_at",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      // {
      //   Header: "Tracking ID",
      //   accessor: "track",
      //   Cell: ({ value, row }) => {
      //     return (
      //       <p className="text-nowrap " style={{ color: "#1A77BC" }}>
      //         {value}
      //       </p>
      //     );
      //   },
      // },

      {
        Header: "Status",
        accessor: "current_status",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex ac-jc">
              <button
                // onClick={() => handleStatus(row)}
                className={`${
                  value == 5
                    ? "technical_btn"
                    : value == 3
                    ? "inventory_button"
                    : value == 7 || value == 8
                    ? "dispatched_btn"
                    : "yet_to_start_btn"
                } f1 fs-xs-12 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-15 fs-xxl-16`}
              >
                {value === 5
                  ? "Technical"
                  : value === 3
                  ? "Inventory"
                  : value === 7 || value == 8
                  ? "Next Visit"
                  : value === 9
                  ? "Senior Support"
                  : value === 14
                  ? "Super Admin"
                  : ""}
              </button>
            </div>
          );
        },
      },
      {
        Header: "Actions",
        accessor: "",
        Cell: ({ value, row }) => {
          const status = row.original.status; // Access current row's status
          return (
            <div className="d-flex ac-jc mt-2 gap-3">
              {/* View button — always visible */}
              <button
                onClick={() => {
                  navigate("/next-visit-view", {
                    state: {
                      type: "view",
                      id: row?.original?.id,
                      status: row?.original?.current_status,
                    },
                  });
                }}
                className="cust-btn "
              >
                <img src={view} alt="" className="editor-btn" />
              </button>

              {/* Edit button — only show if not delivered */}
              {status !== "delivered" && row?.original?.current_status == 8 && (
                <button
                  onClick={() => {
                    navigate("/next-visit-view", {
                      state: {
                        type: "edit",
                        id: row?.original?.id,
                        status: row?.original,
                      },
                    });
                  }}
                  className="cust-btn "
                >
                  <img src={edit} alt="" className="editor-btn" />
                </button>
              )}
            </div>
          );
        },
      },
    ],
    []
  );
  return (
    <>
      <Topbar header={"Next Visit"} />
      <div className="container_fluit1">
        <div className="d-flex ac-jb">
          <h4 className="f3 fs-sm-15 fs-md-19 fs-lg-20 fs-xl-22 fs-xxl-24">
            Total Count : {count}
          </h4>
        </div>
        <div className="d-flex ac-je gap-4">
          <DateRange
            fromDate={fromDates}
            setFromDate={(val) =>
              ticketList(searchValue, selected, val, toDates)
            }
            toDate={toDates}
            setToDate={(val) =>
              ticketList(searchValue, selected, fromDates, val)
            }
          />

          <div className="col-md-2">
            <SelectBox
              selected={statusVal}
              setSelected={setStatusVal}
              options={statusOptions}
            />
          </div>
          <div className="col-md-2">
            <SelectBox
              options={regionOptions}
              selected={selected}
              setSelected={(val) =>
                ticketList(searchValue, val, fromDates, toDates)
              }
            />
          </div>

          <div className="search-input col-md-3 d-flex ac-jb my-4">
            <input
              value={searchValue}
              onChange={(e) =>
                setSearchValue(e.target.value, selected, fromDates, toDates)
              }
              type="text"
              placeholder="Search "
              className="search-field f2 fs-sm-13 fs-md-15 fs-lg-16 fs-xl-18 fs-xxl-20"
            />
            <img src={search} className="search" />
          </div>
        </div>
        <Table
          columns={columns}
          setPageno={setPage}
          // pagecount={pagination}
          data={list ?? []}
          show={true}
          pageno={page}
        />
      </div>
    </>
  );
};

export default NextVisit;
